import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'

/**
 * Export given data to a excel sheet
 * @param {Record<string, string>[]} columns
 * @param {any[]} data
 * @param {string} fileName
 * @param {string} sheetName
 */
export const exportToExcel = (
  columns: Record<string, string>,
  data: Record<string, unknown>[],
  fileName: string,
  sheetName = 'Users'
) => {
  if (!data?.length) return

  const formattedData = data.map((row) => {
    const newRow: Record<string, unknown> = {}

    Object.entries(columns).forEach(([dbName, displayName]) => {
      newRow[displayName] = row[dbName]
    })

    return newRow
  })

  const worksheet = XLSX.utils.json_to_sheet(formattedData)
  const workbook = XLSX.utils.book_new()

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  })

  const exclData = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  })

  saveAs(exclData, `${fileName}.xlsx`)
}
